import { fieldTypeOf } from '../../field-types';
import type { FieldElement } from '../../format/form-definition';
import { DrawerSection } from '../drawer/DrawerSection';
import { CardSettings } from './CardSettings';

export const SettingsSection = ({ field }: { field: FieldElement }) => {
  if (fieldTypeOf(field).settingsPanel?.at !== 'settings') return null;
  return <DrawerSection sections={[{ id: 'settings', title: 'Settings', content: <CardSettings field={field} /> }]} />;
};
